import { observer } from 'mobx-react';
import React from 'react';
import styles from './DeviceList.module.css';
import whatsappIcon from '../../../assets/images/whatsapp.png';

function DeviceList({ devices, onDeviceClick, onOtherDeviceClick, searchValue, currentManufacturer }) {
  // Filter out devices with deviceID === -1 from display (they're handled by the "Other device" button)
  const filteredDevices = devices.map((manufacturerDevices) => ({
    ...manufacturerDevices,
    devices: manufacturerDevices.devices.filter((device) => device.deviceID !== -1)
  })).filter((manufacturerDevices) => manufacturerDevices.devices.length > 0);

  const otherDeviceText = searchValue && searchValue.trim().length > 0
    ? `Other device: ${searchValue.trim()}`
    : 'Other device';

  const handleOtherDeviceClick = () => {
    if (searchValue && searchValue.trim().length > 0) {
      // If there's text, act like "Use" button - navigate to device page
      onDeviceClick({
        deviceID: -1,
        device: searchValue.trim(),
        manufacturer: currentManufacturer || 'Other',
      });
    } else {
      // If no text, focus the input
      onOtherDeviceClick();
    }
  };

  return (
    <div className={styles.container}>
      {filteredDevices.map((manufacturerDevices) => {
        if (manufacturerDevices.devices.length > 0) {
          return (
            <div
              className={styles.manufacturerContainer}
              key={manufacturerDevices.manufacturerID}
            >
              <p className={styles.manufacturerName}>
                {manufacturerDevices.manufacturer}
              </p>
              {manufacturerDevices.devices.map((device) => (
                <p
                  key={device.deviceID}
                  className={styles.deviceName}
                  onClick={() =>
                    onDeviceClick({
                      ...device,
                      manufacturer: manufacturerDevices.manufacturer,
                    })
                  }
                >
                  {device.device}
                </p>
              ))}
            </div>
          );
        } else {
          return false;
        }
      })}
      {onOtherDeviceClick && (
        <p
          className={styles.deviceName}
          onClick={handleOtherDeviceClick}
          style={{ marginTop: '0.5rem' }}
        >
          {otherDeviceText}
        </p>
      )}
      <p className='small' style={{ paddingTop: 20, display: 'flex', flexDirection: 'row', gap: 8, alignItems: 'center', justifyContent: 'center' }}>
        If you're not sure
        <a
          href="https://wa.me/447475703912"
          target="_blank"
          rel="noreferrer"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
        >
          contact us on WhatsApp
          <img src={whatsappIcon} alt="WhatsApp" style={{ width: 32, height: 32, objectFit: 'contain' }} />
        </a>
      </p>
    </div>
  );
}

export default observer(DeviceList);
